// Utility functions for managing the welcome modal

export const clearWelcomeModalFlag = () => {
  localStorage.removeItem('chezalex-welcome-dismissed');
};

export const setWelcomeModalDismissed = () => {
  localStorage.setItem('chezalex-welcome-dismissed', 'true');
};

export const isWelcomeModalDismissed = (): boolean => {
  return localStorage.getItem('chezalex-welcome-dismissed') === 'true';
};

// For development testing - expose to window object
if (typeof window !== 'undefined') {
  (window as any).clearWelcomeModal = clearWelcomeModalFlag;
  (window as any).setWelcomeModalDismissed = setWelcomeModalDismissed;
}